import ChatLeftPanel from './ChatLeftPanel';

export default ChatLeftPanel;
